// Suppresses a gallery reopen right after a close, keyed by comp/property id rather than the
// photos array reference -- a rebuilt comp object (recompute, search) gets a new array every time
// even when the photos themselves are unchanged. See src/components/README.md for the mechanism.
const COOLDOWN_MS = 400

let closedAt = -Infinity
let closedId = null

export function markGalleryClosed(id) {
  closedAt = performance.now()
  closedId = id
}

export function galleryJustClosed(id) {
  return id != null && id === closedId && performance.now() - closedAt < COOLDOWN_MS
}

// Phantom-click guard: suppresses every click anywhere for the window below, regardless of
// destination -- a different question from the reopen cooldown above (is this a reopen of the SAME
// gallery). See src/components/README.md for the mechanism and why it lives at module scope, not a
// React effect.
const PHANTOM_CLICK_GUARD_MS = 300

let disarmGuard = null

function handlePhantomClick(e) {
  e.preventDefault()
  e.stopPropagation()
  // Deliberately no disarmGuard() here: a rapid triple-click's third click can still land inside
  // the same window as the first two, and disarming on click 1 would let it through. Only the
  // fallback timeout below (or an explicit disarmPhantomClickGuard() call) ends the window.
}

export function armPhantomClickGuard() {
  disarmGuard?.() // clears any still-waiting guard's timer -- without this a stale timeout can
  // fire later and tear down a *different*, still-legitimate guard a later close armed
  const timeoutId = setTimeout(() => disarmGuard(), PHANTOM_CLICK_GUARD_MS)
  disarmGuard = () => {
    document.removeEventListener('click', handlePhantomClick, true)
    clearTimeout(timeoutId)
    disarmGuard = null
  }
  document.addEventListener('click', handlePhantomClick, true)
}

// Lets a caller (or a test) mark the next click as a genuinely separate, deliberate one rather
// than the phantom this guard exists to catch.
export function disarmPhantomClickGuard() {
  disarmGuard?.()
}
